var BaseModal = (function () {

  function BaseModal(apiClient) {
    this.apiClient = apiClient;
    this.eventHandlers = {
      'closed': []
    };
    this.canClose = true;
  }

  BaseModal.prototype.diactivate = function () {
    this.$modal.hide();
  };

  BaseModal.prototype.loadContent = function(url, data) {
    const self = this;
    const $modal = ModalHelper.create().show().busy();

    self.$modal = $modal;

    return new Promise((resolve, reject) => {

      self.apiClient.load(url)
        .then((htmlContent) => {

          for (let key in data) {
            if (data.hasOwnProperty(key)) {
              htmlContent = htmlContent.replace('\${' + key + '}', data[key]);
            }
          }

          $modal.content(htmlContent).busy(false);
          $modal
            .on('click', '[js=close],.close', () => { self.close({ cancel: true }) })
            .on('keydown',
              e => {
                if (e.keyCode === 27) {
                  self.close({ cancel: true });
                  e.stopPropagation();
                }
              });
          $(document).on('click', '.modal.in', function (evt) {
            if (evt.target.className === 'modal fade in') {
              self.close({ cancel: true });
            }
          });
          _init($modal);
          resolve($modal);
        })
        .catch(() => {
          ModalHelper.showError($modal).busy(false);
          reject($modal);
        });

    });
  };

  BaseModal.prototype.reloadContent = function (url, data) {
    const self = this;
    const $modal = self.$modal;
    $modal.busy();

    return new Promise((resolve, reject) => {

      self.apiClient.load(url)
        .then((htmlContent) => {

          for (let key in data) {
            if (data.hasOwnProperty(key)) {
              htmlContent = htmlContent.replace('\${' + key + '}', data[key]);
            }
          }

          $modal.content(htmlContent).busy(false);
          _init($modal);
          resolve($modal);
        })
        .catch(() => {
          ModalHelper.showError($modal).busy(false);
          reject($modal);
        });

    });
  };

  BaseModal.prototype.show = function () {
    this.$modal.modal();
  };

  BaseModal.prototype.close = function (modalResult) {
    this.diactivate();
    this.$modal.remove();

    this.eventHandlers['closed'].forEach(function (handler) {
      handler(modalResult);
    });
  };

  BaseModal.prototype.closed = function (onClosed) {
    if (typeof onClosed !== 'function') {
      throw new ArgumentException(onClosed + ' is not a function.');
    }

    this.eventHandlers['closed'].push(onClosed);
    return this;
  };

  BaseModal.prototype.on = function (eventName, handler) {
    if (typeof handler !== 'function') {
      throw new ArgumentException('Parameter "handler" is not a function.');
    }
    if (!this.eventHandlers.hasOwnProperty(eventName))
      this.eventHandlers[eventName] = [];
    this.eventHandlers[eventName].push(handler);
    return this;
  };

  BaseModal.prototype.trigger = function (eventName, eventData) {
    var self = this;
    this.eventHandlers[eventName].forEach(function (handler) {
      handler(self, eventData);
    });
  };


  BaseModal.prototype.tryClose = function () {
    return true;
  };

  function _init($modal) {
    // Инициализация select2
    $('.select2', $modal).select2();
    // Навигация по клику на элемент select2
    $('.select2-selection__choice', $modal).on('click', function () {
      const option = Select2Helper().findOption($(this));
      const href = option.data("href");
      if (href) {
        location.href = href;
      }
    });
  };

  return BaseModal;
}());
